import React from 'react';
import { Card, CardBody, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import classnames from 'classnames';
import CompanyEdit from '../companies/company-edit';
import BillingTab from './billing-tab';
import { COMPANY_SUSPENSION_EVENT } from '../../utils/session';
import { isCompanySuspended } from '../../layouts/layout-components/suspension/suspension-banner';

const TABS = [
	{ id: 'company-settings', label: 'Company settings' },
	{ id: 'billing', label: 'Billing' },
	{ id: 'usage', label: 'Usage' },
	{ id: 'admins', label: 'Admins' },
];

// The only tab a suspended company's admin can use (to pay and lift the suspension)
const SUSPENDED_TAB = 'billing';

class AccountPage extends React.Component {
	constructor(props) {
		super(props);
		const fromUrl = new URLSearchParams((props.location && props.location.search) || '').get('tab');
		const suspended = isCompanySuspended();
		this.state = {
			activeTab: suspended ? SUSPENDED_TAB : (TABS.some((tab) => tab.id === fromUrl) ? fromUrl : 'company-settings'),
			suspended: suspended
		};
		this.toggleTab = this.toggleTab.bind(this);
		this.onSuspensionChange = this.onSuspensionChange.bind(this);
	}

	componentDidMount() {
		window.addEventListener(COMPANY_SUSPENSION_EVENT, this.onSuspensionChange);
	}

	componentWillUnmount() {
		window.removeEventListener(COMPANY_SUSPENSION_EVENT, this.onSuspensionChange);
	}

	// Suspended: back to Billing with the other tabs disabled; reactivated: every tab works again
	onSuspensionChange() {
		const suspended = isCompanySuspended();
		this.setState((state) => ({
			suspended: suspended,
			activeTab: suspended ? SUSPENDED_TAB : state.activeTab
		}));
		if (suspended) {
			this.rememberTab(SUSPENDED_TAB);
		}
	}

	toggleTab(tab) {
		if (this.state.suspended && tab !== SUSPENDED_TAB) {
			return;
		}
		if (this.state.activeTab !== tab) {
			this.setState({ activeTab: tab });
			this.rememberTab(tab);
		}
	}

	// The open tab in the address (?tab=billing), so a refresh (F5) stays on it
	rememberTab(tab) {
		const { history, location } = this.props;
		if (!history || !location) {
			return;
		}
		const params = new URLSearchParams(location.search || '');
		if (params.get('tab') === tab) {
			return;
		}
		params.set('tab', tab);
		history.replace({ pathname: location.pathname, search: '?' + params.toString() });
	}

	render() {
		const { activeTab, suspended } = this.state;
		return (
			<Card>
				<CardBody>
					<Nav tabs>
						{TABS.map((tab) => {
							const disabled = suspended && tab.id !== SUSPENDED_TAB;
							return (
								<NavItem key={tab.id} style={disabled ? { cursor: 'not-allowed' } : undefined}>
									<NavLink
										className={classnames({ active: activeTab === tab.id })}
										disabled={disabled}
										aria-disabled={disabled}
										style={disabled ? { color: '#adb5bd', pointerEvents: 'none' } : { cursor: 'pointer' }}
										onClick={() => this.toggleTab(tab.id)}
									>
										{tab.label}
									</NavLink>
								</NavItem>
							);
						})}
					</Nav>
					<TabContent activeTab={activeTab}>
						<TabPane tabId="company-settings">
							{!suspended && <CompanyEdit />}
						</TabPane>
						<TabPane tabId="billing">
							{activeTab === 'billing' && <BillingTab />}
						</TabPane>
						<TabPane tabId="usage">
							<p className="mt-3">Coming soon</p>
						</TabPane>
						<TabPane tabId="admins">
							<p className="mt-3">Coming soon</p>
						</TabPane>
					</TabContent>
				</CardBody>
			</Card>
		);
	}
}

export default AccountPage;
